// CartItem.jsx
import React, { useState } from 'react';
import noImage from '../slike/noImage.png';
import { formatPrice } from '../../../../../utils/FormatPrice';
import '../index.css';
import { useTranslation } from 'react-i18next';

const CartItem = ({
  item,
  updateQuantity,
  removeItemFromCart,
  handleOpenDetail,
}) => {
  const { t, i18n } = useTranslation();
  const [quantity, setQuantity] = useState(item.kolicina);

  const increment = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);
    updateQuantity(item.id, newQuantity);
  };

  const decrement = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (quantity >= 0) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      updateQuantity(item.id, newQuantity);
    }
  };

  return (
    <div>
      <div className="cart-item" onClick={(e) => handleOpenDetail(e, item)}>
        <img
          src={item.slikaUrl || noImage}
          alt={item.nazivDela}
          className="cart-item-image"
        />
        <div className="cart-item-details">
          <p className="cart-item-name">{item.nazivDela}</p>
          <p className="cart-item-name">
            {t('partNumber')}: {item.partNumber}
          </p>
          <p className="cart-item-name">
            {t('price')}: {formatPrice(item.fakturnaCena)}{' '}
            <span style={{ color: 'gray', fontSize: '15px' }}>EUR</span>
          </p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className="cart-item-quantity" aria-hidden="false">
            <button
              className="quantity-button"
              style={{ paddingBottom: '6px' }}
              onClick={(e) => decrement(e)}
            >
              -
            </button>
            <span className="quantity">{item.kolicina}</span>
            <button className="quantity-button" onClick={(e) => increment(e)}>
              +
            </button>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <p
              className="cart-item-name"
              style={{ minWidth: '100px', textAlign: 'right' }}
            >
              {formatPrice(item.fakturnaCena * item.kolicina)}
            </p>
            <span style={{ color: 'gray' }}>EUR</span>
          </div>
        </div>
        <div className="close" onClick={(e) => removeItemFromCart(e, item)}>
          <i className=" fas fa-times" />
        </div>
      </div>
    </div>
  );
};

export default CartItem;
